import React from 'react';
import dayjs from 'dayjs';
import { setColumnSort } from '../../../libs/utils';
import ExercisePopover from './exercise_popover';
//----------------------------------------------------------------------------------------------------
// images
import ico_more from '../../../assets/images/ico_more.png';
//----------------------------------------------------------------------------------------------------
const ExerciseColumns = (props) => {
  const { sorts, setSorts, loading, setLoading, OnCellClick, ...rests } = props;
  return [
    {
      title: (filters, sortOrder) => {
        return (
          <div
            onClick={(e) => {
              setSorts((prev) => setColumnSort(prev, 'kor_name'));
            }}
            style={{ ...styles.col_headers }}
          >
            {'운동동작[Eng/Kor]'}
          </div>
        );
      },
      width: 200,
      dataIndex: 'kor_name',
      key: 'kor_name',
      sorter: true,
      render: (value, obj) => (
        <div
          style={{ ...styles.col_text }}
          onClick={(e) => {
            OnCellClick({ id: obj.id });
          }}
        >
          {`${obj.eng_name}/${obj.kor_name}`}
        </div>
      ),
    },
    /* ---------- */
    {
      title: (filters, sortOrder) => {
        return (
          <div
            onClick={(e) => {
              setSorts((prev) => setColumnSort(prev, 'big_category'));
            }}
            style={{ ...styles.col_headers }}
          >
            {'대분류'}
          </div>
        );
      },
      width: 100,
      dataIndex: 'big_category',
      key: 'big_category',
      sorter: true,
      render: (value, obj) => (
        <div
          style={{ ...styles.col_text }}
          onClick={(e) => {
            OnCellClick({ id: obj.id });
          }}
        >
          {value}
        </div>
      ),
    },
    /* ---------- */
    {
      title: (filters, sortOrder) => {
        return (
          <div
            onClick={(e) => {
              setSorts((prev) => setColumnSort(prev, 'mid_category'));
            }}
            style={{ ...styles.col_headers }}
          >
            {'중분류'}
          </div>
        );
      },
      width: 100,
      dataIndex: 'mid_category',
      key: 'mid_category',
      sorter: true,
      render: (value, obj) => (
        <div
          style={{ ...styles.col_text }}
          onClick={(e) => {
            OnCellClick({ id: obj.id });
          }}
        >
          {value}
        </div>
      ),
    },
    /* ---------- */
    {
      title: (filters, sortOrder) => {
        return (
          <div
            onClick={(e) => {
              setSorts((prev) => setColumnSort(prev, 'small_category'));
            }}
            style={{ ...styles.col_headers }}
          >
            {'소분류'}
          </div>
        );
      },
      width: 100,
      dataIndex: 'small_category',
      key: 'small_category',
      sorter: true,
      render: (value, obj) => (
        <div
          style={{ ...styles.col_text }}
          onClick={(e) => {
            OnCellClick({ id: obj.id });
          }}
        >
          {value}
        </div>
      ),
    },
    /* ---------- */
    {
      title: (filters, sortOrder) => {
        return (
          <div
            onClick={(e) => {
              setSorts((prev) => setColumnSort(prev, 'tag1'));
            }}
            style={{ ...styles.col_headers }}
          >
            {'#태그1'}
          </div>
        );
      },
      width: 80,
      dataIndex: 'tag1',
      key: 'tag1',
      sorter: true,
      render: (value, obj) => (
        <div
          style={{ ...styles.col_text }}
          onClick={(e) => {
            OnCellClick({ id: obj.id });
          }}
        >
          {value}
        </div>
      ),
    },
    /* ---------- */
    {
      title: (filters, sortOrder) => {
        return (
          <div
            onClick={(e) => {
              setSorts((prev) => setColumnSort(prev, 'tag2'));
            }}
            style={{ ...styles.col_headers }}
          >
            {'#태그2'}
          </div>
        );
      },
      width: 80,
      dataIndex: 'tag2',
      key: 'tag2',
      sorter: true,
      render: (value, obj) => (
        <div
          style={{ ...styles.col_text }}
          onClick={(e) => {
            OnCellClick({ id: obj.id });
          }}
        >
          {value}
        </div>
      ),
    },
    /* ---------- */
    {
      title: (filters, sortOrder) => {
        return (
          <div
            onClick={(e) => {
              setSorts((prev) => setColumnSort(prev, 'tag3'));
            }}
            style={{ ...styles.col_headers }}
          >
            {'#태그3'}
          </div>
        );
      },
      width: 80,
      dataIndex: 'tag3',
      key: 'tag3',
      sorter: true,
      render: (value, obj) => (
        <div
          style={{ ...styles.col_text }}
          onClick={(e) => {
            OnCellClick({ id: obj.id });
          }}
        >
          {value}
        </div>
      ),
    },
    /* ---------- */
    {
      title: (filters, sortOrder) => {
        return (
          <div
            onClick={(e) => {
              setSorts((prev) => setColumnSort(prev, 'created_at'));
            }}
            style={{ ...styles.col_headers }}
          >
            {'등록일'}
          </div>
        );
      },
      width: 112,
      dataIndex: 'created_at',
      key: 'created_at',
      sorter: true,
      render: (value, obj) => {
        return (
          <div
            style={{ ...styles.col_text }}
            onClick={(e) => {
              OnCellClick({ id: obj.id });
            }}
          >
            {(value && dayjs(value).format('YYYY.MM.DD')) || '-'}
          </div>
        );
      },
    },
    /* ---------- */
    {
      title: (filters, sortOrder) => {
        return (
          <div
            onClick={(e) => {
              setSorts((prev) => setColumnSort(prev, 'is_public'));
            }}
            style={{ ...styles.col_headers }}
          >
            {'공개여부'}
          </div>
        );
      },
      width: 130,
      dataIndex: 'is_public',
      key: 'is_public',
      sorter: true,
      render: (value, obj) => {
        let statusStyles = { ...styles.col_plan };
        let publicText = '공개';
        if (value == 'F') {
          statusStyles = {
            ...statusStyles,
            background: 'rgba(255, 159, 67, 0.16)',
            color: '#FF9F43',
          };
          publicText = '비공개';
        }

        return (
          <div
            style={{ ...statusStyles }}
            onClick={(e) => {
              OnCellClick({ id: obj.id });
            }}
          >
            {publicText}
          </div>
        );
      },
    },
    /* ---------- */
    {
      // more
      title: (
        <div
          style={{
            display: 'flex',
            width: '3rem',
            flexDirection: 'column',
            justifyContetn: 'center',
            alignItems: 'center',
          }}
        >
          <img width={22} height={22} src={ico_more} />
        </div>
      ),
      width: 30,
      // height: 48,
      render: (obj) => {
        return (
          <ExercisePopover
            {...props}
            isPublic={obj?.is_public}
            uuid={obj?.id}
            big={obj?.big_category}
            mid={obj?.mid_category}
            sml={obj?.small_category}
            eng_name={obj?.eng_name}
            kor_name={obj?.kor_name}
            width={30}
            component={<img width={22} height={22} src={ico_more} />}
          />
        );
      },
      fixed: 'right',
    },
  ];
};

//----------------------------------------------------------------------------------------------------
const styles = {
  col_headers: {
    fontFamily: 'Public Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '1.3rem',
    lineHeight: '1.5rem',
    letterSpacing: 1,
    textTransform: 'uppercase',
  },
  col1: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  col1_text: {
    display: 'flex',
    marginLeft: '1rem',
    wordWrap: true,

    // font
    fontFamily: 'Public Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '1.5rem',
    lineHeight: '2.2rem',
  },
  col_text: {
    display: 'flex',
    marginLeft: '1rem',
    wordWrap: true,

    // font
    fontFamily: 'Public Sans',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '1.5rem',
    lineHeight: '2.2rem',
  },
  col_plan: {
    display: 'flex',
    width: '9.6rem',
    height: '2.4rem',
    wordWrap: true,
    gap: '1rem',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '5px 10px',
    background: 'rgba(40, 199, 111, 0.16)',
    borderRadius: 4,
    color: '#28C76F',
  },
};

export default ExerciseColumns;
